import React from 'react'
import {colors} from '@/constants'
import Input from 'components/UI/input/EditInput'
import {ReactComponent as EditIcon} from '@/assets/svgs/Input/EditIcon.svg'
import TransCustom from '@/components/UI/i18next'
import {t} from 'i18next'

interface AcceptModalInterface {
  value: string
  setValue: (v: string) => void
}

const Index = ({value, setValue}: AcceptModalInterface) => {
  return (
    <>
      <TransCustom
        i18nKey="1220"
        variant="h1"
        style={{wordBreak: 'break-word'}}
        color={colors.yellow}
        textAlign="center"
      />
      <Input
        fullWidth
        placeholder={t('1002') || ''}
        placeholderalign="left"
        variant="standard"
        color="warning"
        SvgIcon={<EditIcon style={{width: '24px', height: '24px'}} />}
        onChange={(e: any) => setValue(e.target.value)}
        value={value}
      />
      <Input
        fullWidth
        placeholder={t('10171') || ''}
        placeholderalign="left"
        variant="standard"
        color="warning"
        onChange={(e: any) => setValue(e.target.value)}
        value={value}
      />
      <Input
        fullWidth
        placeholder={t('1018') || ''}
        placeholderalign="left"
        variant="standard"
        color="warning"
        onChange={(e: any) => setValue(e.target.value)}
        value={value}
      />
    </>
  )
}

export default Index
